// extracted by mini-css-extract-plugin
module.exports = {"loading_spinner":"style_loading_spinner__3Ijs_","loading":"style_loading__372mK"};